import React from "react";
import { getAwsAssets } from "@src/utils";
import styles from "../../../styles/DownloadIcon.module.scss";
import { Image } from "@src/components/Image";

const DownloadIcon = ({ onClick }) => {
  const handleDownloadClicked = (e) => {
    e?.stopPropagation();
    onClick && onClick();
  };

  return (
    <div className={styles.downloadIcon} onClick={handleDownloadClicked}>
      <div
        className={styles.downloadIcon__icon}
        onClick={handleDownloadClicked}
      >
        <Image
          src={getAwsAssets("downArrowIcon.svg", "content")}
          alt="downArrowIcon"
          height={8}
          width={8}
        />
      </div>
    </div>
  );
};

export default DownloadIcon;
